// Simplified product image utility that uses canonical products directly
import { loadCanonicalProducts } from './productMatcher';

// Helper to prepend PUBLIC_URL to image paths
function withPublicUrl(path) {
  if (!path) return path;
  
  // Use BASE_URL for Vite or fall back to production CDN URL
  // This ensures all asset paths are absolute even in embedded contexts
  const base = import.meta.env.BASE_URL || 
               (import.meta.env.MODE === 'production' ? 'https://ddeewr0txvw1f.cloudfront.net' : '');
               
  // Handle absolute URLs (avoid modifying them)
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // Avoid double slashes
  if (path.startsWith('/')) {
    return base.replace(/\/$/, '') + path;
  }
  
  return base + '/' + path;
}

// Default image for fallback
const DEFAULT_IMAGE = withPublicUrl('/products/good-vibes-500.jpg');

/**
 * Gets the image path for a given canonical product
 * @param {object} canonicalProduct - The canonical product object with imagePath property
 * @returns {string} The image path with public URL prepended
 */
export function getProductImagePath(canonicalProduct) {
  if (!canonicalProduct) return DEFAULT_IMAGE;
  
  // Use the imagePath from the canonical product
  if (canonicalProduct.imagePath) {
    return withPublicUrl(canonicalProduct.imagePath);
  }
  
  // Fallback to product category
  if (canonicalProduct.priceCategory === 'legacy') {
    return withPublicUrl('/products/good-feels.png');
  } else if (canonicalProduct.priceCategory === 'pocket') {
    return withPublicUrl('/products/good-vibes-pocket.png');
  } else if (canonicalProduct.priceCategory === 'premium') {
    return withPublicUrl('/products/good-vibes-x.png');
  }
  
  return DEFAULT_IMAGE;
}

/**
 * Gets the video path for a given canonical product
 * @param {object} canonicalProduct - The canonical product object with videoPath property
 * @returns {string|null} The video path with public URL prepended, or null if no video
 */
export function getProductVideoPath(canonicalProduct) {
  if (!canonicalProduct || !canonicalProduct.videoPath) return null;
  
  return withPublicUrl(canonicalProduct.videoPath);
}

// Export all functions
export { withPublicUrl };
export default getProductImagePath;
